<div [ngClass]="[loungeDisplay.length > 1 ? 'c-form-element-checkbox-button01-group' : '']">
  <ng-container *ngFor="let catalog of loungeDisplay">
    <ng-container *ngIf="catalog?.isDisplayStatus !== true; else displayStatus">
      <div
        [ngClass]="[
          'c-form-element-checkbox-button01',
          catalog?.isActive ? '' : 'is-disabled',
          catalog?.isSelected && catalog?.isActive ? 'is-selected' : ''
        ]"
      >
        <div class="c-form-element-checkbox-button01__wrap">
          <input
            type="checkbox"
            name="checkbox{{ uuid }}_{{ flightId }}_{{ travelerId }}_{{ catalog?.ssrCode }}"
            [disabled]="catalog?.isActive !== true"
            id="checkbox{{ uuid }}_{{ flightId }}_{{ travelerId }}_{{ catalog?.ssrCode }}"
            class="c-form-element-checkbox-button01__input"
            value="{{ catalog?.ssrCode }}"
            (change)="onCheckboxChange($event, catalog)"
            [checked]="catalog?.isSelected"
          />
          <label
            for="checkbox{{ uuid }}_{{ flightId }}_{{ travelerId }}_{{ catalog?.ssrCode }}"
            class="c-form-element-checkbox-button01__label"
          >
            <span class="c-form-element-checkbox-button01__text c-form-element-checkbox-button01__text--has-status">
              <span class="c-form-element-checkbox-button01__text-label" *ngIf="getLoungeType(catalog); let loungeType">
                {{ loungeType | staticMsg }}
              </span>
              <span class="c-form-element-checkbox-button01__text-status"
                ><span class="c-amount c-amount--price">
                  <!-- [12] サービス金額 -->
                  {{ catalog?.paidServiceAmount ?? 0 | amountFormat : undefined : catalog?.currencyCode }}
                </span></span
              >
            </span>
            <span class="c-form-element-checkbox-button01__check"></span>
          </label>
        </div>
      </div>
    </ng-container>
    <ng-template #displayStatus>
      <div class="p-input-block02__row-body-item">
        <div class="c-status-display">
          <span class="c-status-display__body c-status-display__body--has-status">
            <span class="c-status-display__text">
              <span class="c-status-display__text-label" *ngIf="getLoungeType(catalog); let loungeType">
                {{ loungeType | staticMsg }}
              </span>
            </span>
            <span
              class="c-status-display__status c-status-display__status--gray60"
              [innerHTML]="catalog?.status"
            ></span>
          </span>
        </div>
      </div>
    </ng-template>
  </ng-container>
</div>
